import React, { Component } from "react";
import { Redirect, Link } from "react-router-dom";
import Icon from "react-icons-kit";
import { arrowLeft } from "react-icons-kit/fa/arrowLeft";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Profile.scss";
import { withTranslation } from "react-i18next";

class Profile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: true,
      loggedIn: false,
      error: null,
      loaderUpload: false,
      loaderButton: false,
      loading: true,
      verified: null,
      email: null,
      userType: null,
      phone: null,
      companyName: null,
      fullName: null,
      address: null,
      companyTaxId: null,
      taxIdFile: null,
      currency: "IDR",
      validateSizeTaxId: null,
      selectedFile: null,
      selectedFileName: null,
    };
  }

  componentDidMount() {
    this.getProfile();
  }

  componentWillMount() {}

  fileSelectedHandler = (event) => {
    console.log("filechangehandler ", event.target.files[0]);
    console.log("filechangehandler size ", event.target.files[0].size);
    if (
      event.target.files[0].type === "image/jpeg" ||
      event.target.files[0].type === "image/png"
    ) {
      if (event.target.files[0].size <= 1560000) {
        this.setState({
          selectedFile: event.target.files[0],
          selectedFileName: event.target.files[0].name,
          validateSizeTaxId: false,
        });
      } else {
        this.setState({
          validateSizeTaxId: true,
        });
      }
    }
  };

  fileUploadHandler = () => {
    console.log("fileUploadHandler");
    this.setState({ loaderUpload: true });
    const userData = localStorage.getItem("userData");
    const fd = new FormData();
    fd.append("file", this.state.selectedFile, this.state.selectedFile.name);
    console.log("formData ", fd);
    const options = {
      headers: {
        "Content-Type": "application/json",
        token: JSON.parse(localStorage.getItem("userData")).token,
      },
      onUploadProgress: (ProgressEvent) => {
        console.log(
          "upload progress " +
            (ProgressEvent.loaded / ProgressEvent.total) * 100 +
            "%"
        );
      },
    };
    axios
      .post(
        process.env.REACT_APP_API_HOST +
          "/profile/uploadtax/" +
          JSON.parse(userData).data.id,
        fd,
        options
      )
      .then(
        (res) => {
          console.log("res file upload ", res);
          if (res.data.status === true) {
            setTimeout(() => {
              toast.success("Sukses! Tax file berhasil tersimpan");
              this.setState({
                loaderUpload: false,
                taxIdFile: res.data.data,
                selectedFile: null,
                selectedFileName: null,
              });
            }, 1000);
          } else {
            toast.error("Error! " + res.data.error);
            setTimeout(() => {
              this.setState({ loaderUpload: false });
            }, 1000);
          }
        },
        (error) => {
          toast.error("Error! " + error);
          setTimeout(() => {
            this.setState({ loaderUpload: false });
          }, 1000);
        }
      );
  };

  getProfile = () => {
    axios
      .get(process.env.REACT_APP_API_HOST + "/profile", {
        headers: {
          "Content-Type": "application/json",
          token: JSON.parse(localStorage.getItem("userData")).token,
        },
      })
      .then((res) => {
        console.log("get profile ", res.data);
        if (res.data.status === true) {
          if (res.data.data.userType === 0) {
            // User Personal
            this.setState({
              loggedIn: true,
              loading: false,
              userType: res.data.data.userType,
              verified: res.data.data.verified,
              email: res.data.data.email,
              phone: res.data.data.phone,
              fullName: res.data.data.fullName,
              address: res.data.data.address,
            });
          } else {
            // User Business
            this.setState({
              loggedIn: true,
              loading: false,
              userType: res.data.data.userType,
              verified: res.data.data.verified,
              email: res.data.data.email,
              phone: res.data.data.phone,
              companyName: res.data.data.companyName,
              companyTaxId: res.data.data.companyTaxId,
              address: res.data.data.address,
              taxIdFile: res.data.data.taxIdFile,
            });
          }
        }
      });
  };
  updateBusiness = (e) => {
    e.preventDefault();
    this.setState({ loaderButton: true });
    let data = {
      address: this.state.address,
      phone: this.state.phone,
      companyName: this.state.companyName,
      companyTaxId: this.state.companyTaxId,
      currency: this.state.currency,
    };
    axios({
      method: "put",
      url: process.env.REACT_APP_API_HOST + "/profile/user/business",
      headers: {
        "Content-Type": "application/json",
        token: JSON.parse(localStorage.getItem("userData")).token,
      },

      data: data,
    }).then(
      (response) => {
        if (response.data.status) {
          // localStorage.setItem('userData', JSON.stringify(response.data.data));
          setTimeout(() => {
            toast.success("Sukses! Data berhasil diubah");
            this.setState({ loaderButton: false });
          }, 1000);
        } else {
          if (response.data.error.length) {
            for (var er = 0; er < response.data.error.length; er++) {
              var obj = response.data.error[er];
              for (var key in obj) {
                console.log(key, obj[key]);
                toast.error(key + " : " + obj[key]);
              }
              this.setState({ loaderButton: false });
            }
          } else {
            this.setState({ loaderButton: false });
            toast.error(response.data.error);
          }
        }
      },
      (error) => {
        toast.error("Error! " + error);
        setTimeout(() => {
          this.setState({ loaderButton: false });
        }, 1000);
      }
    );
  };
  updatePersonal = (e) => {
    e.preventDefault();
    this.setState({ loaderButton: true });
    let data = {
      address: this.state.address,
      phone: this.state.phone,
      fullName: this.state.fullName,
      currency: this.state.currency,
      gender: "",
      birthDate: "",
      password: "",
    };
    axios({
      method: "put",
      url: process.env.REACT_APP_API_HOST + "/profile/user/personal",
      headers: {
        "Content-Type": "application/json",
        token: JSON.parse(localStorage.getItem("userData")).token,
      },
      data: data,
    }).then(
      (response) => {
        if (response.data.status) {
          // localStorage.setItem('userData', JSON.stringify(response.data.data));
          setTimeout(() => {
            toast.success("Sukses! Data berhasil diubah");
            this.setState({ loaderButton: false });
          }, 1000);
        } else {
          if (response.data.error.length) {
            for (var er = 0; er < response.data.error.length; er++) {
              var obj = response.data.error[er];
              for (var key in obj) {
                console.log(key, obj[key]);
                toast.error(key + " : " + obj[key]);
              }
              this.setState({ loaderButton: false });
            }
          } else {
            this.setState({ loaderButton: false });
            toast.error(response.data.error);
          }
        }
      },
      (error) => {
        toast.error("Error! " + error);
        setTimeout(() => {
          this.setState({ loaderButton: false });
        }, 1000);
      }
    );
  };

  render() {
    if (!localStorage.getItem("userData")) {
      return <Redirect to={"/"} />;
    }
    return (
      <React.Fragment>
        <div className="nav nav-main-bottom shadow-bottom">
          <div className="container">
            <div className="row align-items-center">
              <div className="col">
                <ul className="nav-tab">
                  <li className="active">
                    <Link data-menu="profile" to="#">
                      {this.props.t("Profile.link_profil")}
                    </Link>
                  </li>
                  <li>
                    <Link data-menu="changepassword" to="/change-password">
                      {this.props.t("Profile.link_ubahPassword")}
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="mpl-page login">
          <ToastContainer />
          {this.state.loading === true ? (
            <div className="text-center">
              {" "}
              {this.props.t("Profile.text_mengambilData")}
            </div>
          ) : (
            <div className="container">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="card-body p-0">
                      {this.state.verified === false ? (
                        <div className="row justify-content-center">
                          <div className="col-sm-5">
                            <div className="alert alert-danger text-center mb-4">
                              {this.props.t("Profile.text_cekEmail")}
                            </div>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}

                      {this.state.userType === 0 ? (
                        <div className="row user-personal justify-content-center">
                          <div className="col-sm-12 col-md-5">
                            <h3 className="mt-0">
                              {this.props.t("Profile.text_ubahProfil")}
                            </h3>
                            <form
                              id="formUpdate"
                              onSubmit={this.updatePersonal}
                            >
                              <div className="row">
                                <div className="col">
                                  <div className="form-group">
                                    <label htmlFor="" className="label-group">
                                      {this.props.t("Profile.label_email")}
                                    </label>
                                    <input
                                      type="text"
                                      className="field-group small-input"
                                      disabled
                                      defaultValue={this.state.email || ""}
                                    />
                                  </div>
                                  <div className="form-group">
                                    <label htmlFor="" className="label-group">
                                      {this.props.t(
                                        "Profile.label_namaLengkap"
                                      )}
                                    </label>
                                    <input
                                      type="text"
                                      className="field-group small-input"
                                      onChange={(e) =>
                                        this.setState({
                                          fullName: e.target.value,
                                        })
                                      }
                                      value={this.state.fullName || ""}
                                    />
                                  </div>
                                  <div className="form-group">
                                    <label htmlFor="" className="label-group">
                                      {this.props.t("Profile.label_telepon")}
                                    </label>
                                    <input
                                      type="text"
                                      className="field-group small-input"
                                      onChange={(e) =>
                                        this.setState({ phone: e.target.value })
                                      }
                                      value={this.state.phone || ""}
                                    />
                                  </div>
                                  <div className="form-group">
                                    <label htmlFor="" className="label-group">
                                      {this.props.t("Profile.label_alamat")}
                                    </label>
                                    <textarea
                                      name=""
                                      id=""
                                      className="field-group"
                                      onChange={(e) =>
                                        this.setState({
                                          address: e.target.value,
                                        })
                                      }
                                      value={this.state.address || ""}
                                    ></textarea>
                                  </div>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col">
                                  <button
                                    className="btn btn-green float-right"
                                    type="submit"
                                  >
                                    {this.state.loaderButton === true ? (
                                      <span>
                                        <i className="fa fa-spin fa-spinner"></i>{" "}
                                        {this.props.t("Profile.btn_tunggu")}
                                      </span>
                                    ) : (
                                      <span>
                                        {" "}
                                        <i className="fa fa-save"></i>
                                        {this.props.t("Profile.btn_ubahProfil")}
                                      </span>
                                    )}
                                  </button>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      ) : (
                        <div className="row user-business justify-content-center">
                          <div className="col-sm-5">
                            <h3 className="mt-0">
                              {this.props.t("Profile.text_ubahProfil")}
                            </h3>
                            <form id="formUpdate">
                              <div className="row">
                                <div className="col">
                                  <div className="form-group">
                                    <label htmlFor="" className="label-group">
                                      {this.props.t(
                                        "Profile.label_emailPerusahaan"
                                      )}
                                    </label>
                                    <input
                                      type="text"
                                      className="field-group small-input"
                                      disabled
                                      defaultValue={this.state.email || ""}
                                    />
                                  </div>
                                  <div className="form-group">
                                    <label htmlFor="" className="label-group">
                                      {this.props.t(
                                        "Profile.label_namaPerusahaan"
                                      )}
                                    </label>
                                    <input
                                      type="text"
                                      className="field-group small-input"
                                      onChange={(e) =>
                                        this.setState({
                                          companyName: e.target.value,
                                        })
                                      }
                                      value={this.state.companyName || ""}
                                    />
                                  </div>
                                  <div className="form-group">
                                    <label htmlFor="" className="label-group">
                                      {this.props.t(
                                        "Profile.label_teleponPerusahaan"
                                      )}
                                    </label>
                                    <input
                                      type="text"
                                      className="field-group small-input"
                                      onChange={(e) =>
                                        this.setState({ phone: e.target.value })
                                      }
                                      value={this.state.phone || ""}
                                    />
                                  </div>
                                  <div className="form-group">
                                    <label htmlFor="" className="label-group">
                                      {this.props.t("Profile.label_alamat")}
                                    </label>
                                    <textarea
                                      name=""
                                      id=""
                                      className="field-group"
                                      onChange={(e) =>
                                        this.setState({
                                          address: e.target.value,
                                        })
                                      }
                                      value={this.state.address || ""}
                                    ></textarea>
                                  </div>
                                  <div className="form-group">
                                    <label htmlFor="" className="label-group">
                                      {this.props.t("Profile.label_idPajak")}
                                    </label>
                                    <input
                                      type="text"
                                      className="field-group small-input"
                                      onChange={(e) =>
                                        this.setState({
                                          companyTaxId: e.target.value,
                                        })
                                      }
                                      value={this.state.companyTaxId || ""}
                                    />
                                  </div>
                                </div>
                              </div>
                            </form>
                            <div className="row">
                              <div className="col">
                                {this.state.taxIdFile !== "" ? (
                                  <div className="wrap-tax tax-fill">
                                    <img
                                      src={
                                        this.state.selectedFile
                                          ? URL.createObjectURL(
                                              this.state.selectedFile
                                            )
                                          : process.env.REACT_APP_IMG_PATH +
                                            `/gaia-query/file/offset-user-tax/${this.state.taxIdFile}`
                                      }
                                      alt="TAX Files"
                                      className="imageTax"
                                    />
                                    <button
                                      onClick={() => this.fileInput.click()}
                                      className="btn btn-select-file"
                                    >
                                      <i className="fa fa-file-upload"></i>
                                      <br />
                                      {this.props.t("Profile.btn_pilihBerkas")}
                                    </button>
                                  </div>
                                ) : (
                                  <div className="wrap-tax">
                                    <button
                                      onClick={() => this.fileInput.click()}
                                      className="btn btn-select-file"
                                    >
                                      <i className="fa fa-file-upload"></i>
                                      <br />
                                      {this.props.t("Profile.btn_pilihFile")}
                                    </button>
                                  </div>
                                )}
                                <input
                                  style={{ display: "none" }}
                                  type="file"
                                  onChange={this.fileSelectedHandler}
                                  accept="image/*"
                                  ref={(fileInput) =>
                                    (this.fileInput = fileInput)
                                  }
                                />
                                <br />

                                {this.state.selectedFile === null ? (
                                  <div>
                                    <button
                                      onClick={() => this.fileInput.click()}
                                      className="btn btn-outline-orange"
                                    >
                                      <i className="fa fa-file-upload"></i>
                                      &nbsp;
                                      {this.props.t(
                                        "Profile.btn_pilihBerkasPajak"
                                      )}
                                    </button>
                                    {this.state.validateSizeTaxId === true ? (
                                      <div className="text-red">
                                        {this.props.t(
                                          "Profile.text_validasiBerkas"
                                        )}
                                      </div>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                ) : (
                                  <div>
                                    <button
                                      onClick={this.fileUploadHandler}
                                      className="btn btn-green mb-1"
                                    >
                                      {this.state.loaderUpload === true ? (
                                        <span>
                                          <i className="fa fa-spin fa-spinner"></i>{" "}
                                          {this.props.t("Profile.btn_tunggu")}
                                        </span>
                                      ) : (
                                        <span>
                                          {" "}
                                          <i className="fa fa-save"></i>{" "}
                                          {this.props.t(
                                            "Profile.btn_simpanBerkasPajak"
                                          )}
                                        </span>
                                      )}
                                    </button>
                                    <div>
                                      <small>
                                        {this.props.t("Profile.label_berkas")} :{" "}
                                        {this.state.selectedFileName}
                                      </small>
                                    </div>
                                  </div>
                                )}
                                <br />
                              </div>
                            </div>
                            <div className="row">
                              <div className="col">
                                <button
                                  className="btn btn-green float-right"
                                  onClick={this.updateBusiness}
                                >
                                  {this.state.loaderButton === true ? (
                                    <span>
                                      <i className="fa fa-spin fa-spinner"></i>{" "}
                                      {this.props.t("Profile.btn_tunggu")}
                                    </span>
                                  ) : (
                                    <span>
                                      {" "}
                                      <i className="fa fa-save"></i>{" "}
                                      {this.props.t("Profile.btn_ubahProfil")}
                                    </span>
                                  )}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </React.Fragment>
    );
  }
}

export default withTranslation()(Profile);
